/* Best-Preis motion: scroll reveal. No tracking, no storage, no layout thrash. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Tells the inline fail-safe in theme.liquid that reveal is under control here.
  document.documentElement.dataset.bpRevealed = '1';

  var SEL = '.section, product-card, .bp-trust, .bp-grade, .bp-cscale, .collection-card, .footer .group-block';

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('is-in');
          io.unobserve(entries[i].target);
        }
      }
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.04 }
  );

  function run() {
    var candidates = document.querySelectorAll(SEL);
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.dataset.bpMarked) continue;
      el.dataset.bpMarked = '1';
      el.classList.add('bp-reveal');
      el.dataset.delay = String(i % 4);
    }
    var pending = document.querySelectorAll('.bp-reveal:not(.is-in)');
    for (var j = 0; j < pending.length; j++) {
      var p = pending[j];
      if (p.dataset.bpObserved) continue;
      p.dataset.bpObserved = '1';
      // Already in view on load: show immediately, no flash of hidden content.
      var r = p.getBoundingClientRect();
      if (r.top < innerHeight && r.bottom > 0) p.classList.add('is-in');
      else io.observe(p);
    }
  }

  /* ---------------------------------------------------------------- *
   * Cascade: give each item in a grid its position, so the CSS can stagger
   * them. The index is capped so the last card of a 60-item collection is not
   * still waiting three seconds after the first.
   * ---------------------------------------------------------------- */
  var CASCADES = ['.bp-grid', '.product-grid', '.resource-list', '.bp-cats', '.bp-catbans', '.bp-subcats', '.bp-scale'];
  var MAX_STEP = 7;

  function cascade() {
    for (var c = 0; c < CASCADES.length; c++) {
      var groups = document.querySelectorAll(CASCADES[c]);
      for (var g = 0; g < groups.length; g++) {
        var kids = groups[g].children;
        for (var k = 0; k < kids.length; k++) {
          if (kids[k].style.getPropertyValue('--i')) continue;
          kids[k].style.setProperty('--i', String(Math.min(k, MAX_STEP)));
        }
      }
      // The container carries .is-in, which releases its children in CSS.
      for (var g2 = 0; g2 < groups.length; g2++) {
        (function (el) {
          if (el.dataset.bpCascade) return;
          el.dataset.bpCascade = '1';
          io2.observe(el);
        })(groups[g2]);
      }
    }
  }

  var io2 = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('bp-in');
          io2.unobserve(entries[i].target);
        }
      }
    },
    { rootMargin: '0px 0px -4% 0px', threshold: 0.01 }
  );

  /* ---------------------------------------------------------------- *
   * Photos fade in rather than snapping, and the shimmer behind them stops.
   * ---------------------------------------------------------------- */
  /* Marks the photo AND its frame. The frame class is what stops the shimmer
     on browsers without :has() - iOS Safari before 15.4, Firefox before 121 -
     where the :has() stop rule is dropped and the photo would shimmer forever. */
  function ready(img) {
    img.classList.add('is-loaded');
    img.setAttribute('data-bp-ready', '');
    var frame = img.closest ? img.closest('.bp-card__media') : null;
    if (frame) frame.classList.add('is-ready');
  }

  /* The standing display rule (photoless and sold-out sink) and the zero-price
     guard are written with :has(). An unsupported :has() drops the whole rule,
     which would quietly un-hide zero-price articles on an older iPhone, so the
     same states are mirrored onto plain classes here. */
  function markItems() {
    var items = document.querySelectorAll('.product-grid__item, .resource-list__item');
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var card = it.querySelector('product-card');
      it.classList.toggle(
        'bp-item--nophoto',
        !!it.querySelector('.product-card-gallery__title-placeholder')
      );
      it.classList.toggle('bp-item--sold', !!(card && card.hasAttribute('data-bp-sold')));
      it.classList.toggle('bp-item--zero', !!(card && card.hasAttribute('data-bp-zero')));
    }
  }

  function images() {
    var imgs = document.querySelectorAll('.bp-card__media img, .bp-mosaic__cell img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.bpImg) continue;
      img.dataset.bpImg = '1';
      img.classList.add('bp-fade');
      if (img.complete && img.naturalWidth > 0) {
        ready(img);
      } else {
        (function (el) {
          el.addEventListener('load', function () { ready(el); }, { once: true });
          // A photo that fails must not be left invisible behind a shimmer.
          el.addEventListener('error', function () { ready(el); }, { once: true });
        })(img);
      }
    }
  }

  /* ---------------------------------------------------------------- *
   * The hero stat counts up once. The final text is already rendered by
   * Liquid, so if anything here fails the real number is what stays.
   * ---------------------------------------------------------------- */
  function countUp() {
    var els = document.querySelectorAll('[data-bp-count]');
    for (var i = 0; i < els.length; i++) {
      (function (el) {
        if (el.dataset.bpCounted) return;
        el.dataset.bpCounted = '1';
        var target = parseInt(el.getAttribute('data-bp-count'), 10);
        if (!target || target < 2) return;
        var final = el.textContent;
        var start = null;
        var DUR = 1100;
        function frame(ts) {
          if (start === null) start = ts;
          var p = Math.min(1, (ts - start) / DUR);
          // ease-out: fast first, settles on the number
          var eased = 1 - Math.pow(1 - p, 3);
          if (p >= 1) {
            el.textContent = final;
            return;
          }
          el.textContent = Math.round(target * eased).toLocaleString('de-DE');
          requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      })(els[i]);
    }
  }

  /* ---------------------------------------------------------------- *
   * Hero parallax. Driven by rAF and only while the hero is on screen, so
   * there is no scroll listener and no work at all once it is scrolled past.
   * ---------------------------------------------------------------- */
  function parallax() {
    // Phones skip this entirely: the effect is subtle and the frame budget on a
    // mid-range Android is better spent on the scroll itself.
    if (!matchMedia('(min-width: 750px)').matches) return;
    var hero = document.querySelector('.bp-hero');
    var mosaic = hero && hero.querySelector('.bp-mosaic');
    if (!mosaic || hero.dataset.bpPar) return;
    hero.dataset.bpPar = '1';

    var running = false;
    function tick() {
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) {
        running = false;
        mosaic.style.willChange = '';
        return;
      }
      // A few pixels only. Enough to feel alive, not enough to distract.
      mosaic.style.setProperty('--bp-par', String(Math.round(r.top * -0.04)));
      requestAnimationFrame(tick);
    }

    new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting && !running) {
          running = true;
          mosaic.style.willChange = 'transform';
          requestAnimationFrame(tick);
        }
      }
    }).observe(hero);
  }

  /* ---------------------------------------------------------------- *
   * The cart icon reacts when something lands in it.
   * ---------------------------------------------------------------- */
  document.addEventListener('cart:lines-update', function () {
    var icon = document.querySelector(
      'cart-icon, .header__cart, [data-cart-icon], a[href$="/cart"], a[href*="/cart"]'
    );
    if (!icon) return;
    icon.classList.remove('bp-cart-bump');
    // Reflow between removing and adding, or the animation will not restart.
    void icon.offsetWidth;
    icon.classList.add('bp-cart-bump');
  });

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      run();
      cascade();
      images();
      tilt();
      markItems();
    });
  }

  /* ---------------------------------------------------------------- *
   * Cards lean towards the pointer. Listeners are attached only while the
   * pointer is actually over a card, and only on devices that hover at all,
   * so a phone never runs any of this.
   * ---------------------------------------------------------------- */
  var CAN_HOVER = matchMedia('(hover: hover)').matches;

  function tilt() {
    if (!CAN_HOVER) return;
    var cards = document.querySelectorAll('.bp-card');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        if (card.dataset.bpTiltBound) return;
        card.dataset.bpTiltBound = '1';

        var frame = 0;
        function move(e) {
          if (frame) return;
          frame = requestAnimationFrame(function () {
            frame = 0;
            var r = card.getBoundingClientRect();
            var px = (e.clientX - r.left) / r.width;
            var py = (e.clientY - r.top) / r.height;
            // Small on purpose. A big tilt reads as a gimmick and hurts
            // readability of the price and the condition badge.
            card.style.setProperty('--tx', ((px - 0.5) * 5).toFixed(2));
            card.style.setProperty('--ty', ((0.5 - py) * 5).toFixed(2));
            card.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
            card.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
          });
        }

        card.addEventListener('pointerenter', function () {
          card.setAttribute('data-bp-tilt', '');
          card.style.willChange = 'transform';
          card.addEventListener('pointermove', move);
        });

        card.addEventListener('pointerleave', function () {
          card.removeEventListener('pointermove', move);
          if (frame) cancelAnimationFrame(frame);
          frame = 0;
          card.removeAttribute('data-bp-tilt');
          card.style.willChange = '';
          card.style.removeProperty('--tx');
          card.style.removeProperty('--ty');
        });
      })(cards[i]);
    }
  }

  /* ---------------------------------------------------------------- *
   * Every primary control answers a tap. Phones have no hover state, so
   * without this a tap feels like nothing happened.
   * ---------------------------------------------------------------- */
  var RIPPLE_SEL = '.bp-btn, .bp-dock__cta, .bp-card__add, .bp-sort__btn, .bp-fab';

  document.addEventListener(
    'pointerdown',
    function (e) {
      var host = e.target && e.target.closest ? e.target.closest(RIPPLE_SEL) : null;
      if (!host || host.disabled) return;
      var r = host.getBoundingClientRect();
      var size = Math.max(r.width, r.height);
      var dot = document.createElement('span');
      dot.className = 'bp-ripple';
      dot.style.width = dot.style.height = size + 'px';
      dot.style.left = e.clientX - r.left - size / 2 + 'px';
      dot.style.top = e.clientY - r.top - size / 2 + 'px';
      host.appendChild(dot);
      dot.addEventListener('animationend', function () {
        dot.remove();
      });
      // Belt and braces: if the animation never fires (reduced motion), the
      // node must still not accumulate in the DOM.
      setTimeout(function () {
        dot.remove();
      }, 900);
    },
    { passive: true }
  );

  /* The scroll progress rail is pure CSS; it only needs an element to exist. */
  function progress() {
    if (document.querySelector('.bp-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'bp-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
  }

  function boot() {
    run();
    cascade();
    images();
    countUp();
    parallax();
    tilt();
    progress();
    markItems();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Horizon swaps sections in on filter/paginate; pick up whatever arrives.
  new MutationObserver(schedule).observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
